import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import {
  GlobalNavigationBar,
  GlobalNavigationBarRegion,
  GlobalNavigationBarLink,
  GlobalNavigationBarDropdown,
} from '@salesforce/design-system-react';
import AddAccount from '../Modal/addAccount';
import AddExchange from '../Modal/addExchange';
import { addNewAccount } from '../../store/accounts/slice';
import { getSyncTime } from '../../services/snapshot';
// import { authSelector } from '../../store/auth/slice';



const Nav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const [isActive, setIsActive] = useState('dashboard');
  // const { user } = useSelector(authSelector);

  const [openAddAccountModal, setOpenAddAccountModal] = useState(false);
  const [openAddExchangeModal, setOpenAddExchangeModal] = useState(false);
  const dispatch = useDispatch();
  const syncTime = getSyncTime();

  const defiOptions = [
    {
      label: (
        <span title="Overview">
          <img src="/assets/icons/menus/overview.svg" alt="overview menu" /> Overview
        </span>
      ),
      value: '/defi/overview',
    },
    {
      label: (
        <span title="Transactions">
          <img src="/assets/icons/menus/transactions.svg" alt="transactions menu" /> Transactions
        </span>
      ),
      value: '/defi/transactions',
    },
    {
      label: (
        <span title="Balances">
          <img src="/assets/icons/menus/balance.svg" alt="defi balance menu" /> Balances
        </span>
      ),
      value: '/defi/balances',
    },
    {
      label: (
        <span title="Protocols">
          <img src="/assets/icons/menus/protocols.svg" alt="protocols menu" /> Protocols
        </span>
      ),
      value: '/defi/protocols',
    },
    {
      label: (
        <span title="Accounts">
          <img src="/assets/icons/menus/accounts.svg" alt="accounts menu" /> Accounts
        </span>
      ),
      value: '/defi/accounts',
    }
  ];

  const addAccountOption = [
    { type: 'divider' },
    {
      label: (
        <span title="Add Account">
          <img src="/assets/icons/menus/add.svg" alt="add accounts" /> Add Account
        </span>
      ),
      value: 'open-add-modal',
    },]

  const exchangeOptions = [
    {
      label: (
        <span title="Overview">
          <img src="/assets/icons/menus/overview.svg" alt="overview menu" /> Overview
        </span>
      ),
      value: '/exchanges/overview',
    },
    {
      label: (
        <span title="Transactions">
          <img src="/assets/icons/menus/transactions.svg" alt="transactions menu" /> Transactions
        </span>
      ),
      value: '/exchanges/transactions',
    },
    {
      label: (
        <span title="Spot Balances">
          <img src="/assets/icons/spot-balance/spot-balance.svg" alt="spot balances" /> Spot Balances
        </span>
      ),
      value: '/exchanges/spot-balance',
    },
    {
      label: (
        <span title="Future">
          <img src="/assets/icons/spot-balance/spot-balance.svg" alt="spot balances" /> Future
          Balances
        </span>
      ),
      value: '/exchanges/margin-balance',
    },
    {
      label: (
        <span title="Exchanges">
          <img src="/assets/icons/menus/exchange.svg" alt="exchanges menu" /> Exchanges
        </span>
      ),
      value: '/exchanges/exchanges',
    },
  ];

  const addExchangeOption = [
    { type: 'divider' },
    {
      label: (
        <span title="Add Exchange">
          <img src="/assets/icons/menus/add.svg" alt="add exchanges" /> Add Exchange
        </span>
      ),

      value: 'open-add-exchange-modal',
    },
  ]

  const NavLinks = [
    { name: 'Home', page: 'home', link: '/home', isDropdown: false, showStandardUser: true },
    {
      name: 'Defi',
      page: 'defi/overview',
      link: '/defi/overview',
      isDropdown: true,
      options: syncTime ? defiOptions : defiOptions.concat(addAccountOption),
    },
    {
      name: 'Exchange',
      page: 'exchanges/overview',
      link: '/exchanges/overview',
      isDropdown: true,
      options: syncTime ? exchangeOptions : exchangeOptions.concat(addExchangeOption),
      showStandardUser: false,
    },
    // {
    //   name: 'Dashboards',
    //   page: 'dashboard',
    //   link: '/dashboard',
    //   isDropdown: false,
    //   showStandardUser: false,
    // },
    // {
    //   name: 'Transactions',
    //   page: 'transaction',
    //   link: '/transaction',
    //   isDropdown: false,
    //   showStandardUser: false,
    // },
    // { name: 'Assets', page: 'assets', link: '/assets', isDropdown: false, showStandardUser: false },
    // {
    //   name: 'Reports',
    //   page: 'reports',
    //   link: '/reports',
    //   isDropdown: false,
    //   showStandardUser: false,
    // },
    {
      name: 'Snapshots',
      page: 'snapshots',
      link: '/snapshots',
      isDropdown: false,
      showStandardUser: true,
    },

    // {
    //   name: 'Users',
    //   page: 'users',
    //   link: '/users',
    //   isDropdown: false,
    //   showStandardUser: true,
    // },

    // {
    //   name: 'Team',
    //   page: 'team',
    //   link: '/team',
    //   isDropdown: false,
    //   showStandardUser: true,
    // },
    // {
    //   name: 'Clients',
    //   page: 'clients',
    //   link: '/clients',
    //   isDropdown: false,
    //   showStandardUser: false,
    // },
  ];


  function onNavigationClick(value) {
    navigate(`/${value}`);
    // setIsActive(value);
  }

  const handleDefiDropdownNavigate = (value) => {
    if (value === 'open-add-modal') {
      setOpenAddAccountModal(true);
    } else if (value === 'open-add-exchange-modal') {
      setOpenAddExchangeModal(true);
    } else {
      navigate(value);
    }
  };
  
  

  const handleFormSubmit = async (formData) => {
    dispatch(addNewAccount(formData));
  };

  return (
    <div>
      <GlobalNavigationBar>
        <GlobalNavigationBarRegion region="primary">
          <p className="slds-truncate slds-context-bar__label-action slds-context-bar__app-name">
            {' '}
            Portfolio Manager
          </p>
        </GlobalNavigationBarRegion>
        <GlobalNavigationBarRegion region="secondary" navigation>
          {NavLinks.map((nl, index) =>
            nl.isDropdown ? (
              <GlobalNavigationBarDropdown
                key={index}
                active={
                  `${location.pathname.split('/')[1]}` === nl.link.split('/')[1] ? true : false
                }
                assistiveText={{ icon: 'Dropdown' }}
                id={`dropdown`}
                label={nl.name}
                openOn="hover"
                onClick={() => onNavigationClick(nl.page)}
                onSelect={({ value }) => handleDefiDropdownNavigate(value)}
                options={nl.options}
                to={'/defi/overview'}
                align="left"
              />
            ) : (
              <GlobalNavigationBarLink
                key={index}
                active={location.pathname === nl.link ? true : false}
                label={nl.name}
                to={nl.page}
                onClick={() => onNavigationClick(nl.page)}
                className={`${!nl.showStandardUser && 'standard-menu-hidden'}`}
              />
            )
          )}
        </GlobalNavigationBarRegion>
      </GlobalNavigationBar>
      <AddAccount
        openModal={openAddAccountModal}
        handleFormSubmit={handleFormSubmit}
        closeModal={() => setOpenAddAccountModal(false)}
      />
      <AddExchange
        openModal={openAddExchangeModal}
        handleFormSubmit={handleFormSubmit}
        closeModal={() => setOpenAddExchangeModal(false)}
      />
    </div>
  );
};

export default Nav;
